import { Language } from '@breathelife/types';
import { VersionedAnswers } from '@zinnia/form-engine-sdk';

import { BaseApiResponse, BaseQuestionResponse } from '../Models/QuestionResponse';
import { Step } from '../Models/Step';
import ApiService from './ApiService';

const consumerApiService = ApiService.consumer;

type ApiResponse = BaseApiResponse & {
  step: Step;
};

export type QuestionResponse = BaseQuestionResponse & {
  step: Step;
};

export async function createApplication(data?: unknown): Promise<QuestionResponse | { id: string }> {
  const applicationResponse = await consumerApiService.createApplication(data);
  return applicationResponse.data;
}

export async function updateApplication(
  applicationId: string,
  language: Language,
  data: { lang?: Language; premium?: number | null },
): Promise<QuestionResponse> {
  const applicationResponse = await consumerApiService.updateApplication<QuestionResponse>(
    applicationId,
    language,
    data,
  );
  return applicationResponse.data;
}

export async function fetchApplication(insuranceApplicationId: string): Promise<QuestionResponse> {
  const applicationResponse = await consumerApiService.fetchApplication(insuranceApplicationId);
  return applicationResponse.data;
}

export async function getQuestion(applicationId: string, questionId: string, language: Language): Promise<ApiResponse> {
  const questionResponse = await consumerApiService.fetchQuestion(applicationId, questionId, language);
  return questionResponse.data;
}

export async function getPreviousQuestionData(
  applicationId: string,
  currentQuestionId: string,
  language: Language,
): Promise<ApiResponse> {
  const prevQuestionResponse = await consumerApiService.getPreviousQuestionData(
    applicationId,
    currentQuestionId,
    language,
  );
  return prevQuestionResponse.data;
}

export async function sendQuestionAnswer(
  applicationId: string,
  questionId: string,
  versionedAnswers: VersionedAnswers,
  language: Language,
): Promise<ApiResponse> {
  const answerResponse = await consumerApiService.sendQuestionAnswer(
    applicationId,
    questionId,
    versionedAnswers,
    language,
  );
  return answerResponse.data;
}
